import { CLEAR_INDIVIDUAL_XML_NEWS, CLEAR_XML_NEWS, GET_INDIVIDUAL_XML_NEWS, GET_NOVEDADES_PRESTADORES_CONECTIVIDAD, GET_SERVICE_MONITOR_STATISTICS, GET_XML_NEWS, GET_XML_VALIDATION, POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD, RESEND_XML_NEWS, UPDATE_XML_NEWS } from "../actions/connectivity";

const INITIAL_STATE = {
    xmlValidations: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    novedadesPrestadorConectividad: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    postNovedadesPrestadorConectividad: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    serviceMonitorStatistics: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    xmlNews: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    updatedXmlNewsIds: {
        isFetching: false,
        didInvalidate: false,
        data: [],
    },
    individualXmlNews: {
        isFetching: false,
        didInvalidate: false,
        data: "",
    }
}

const connectivity = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${GET_SERVICE_MONITOR_STATISTICS}_FULFILLED`:
            return {
                ...state,
                serviceMonitorStatistics: {
                    ...state.serviceMonitorStatistics,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${GET_SERVICE_MONITOR_STATISTICS}_REJECTED`:
            return {
                ...state,
                serviceMonitorStatistics: {
                    ...state.serviceMonitorStatistics,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${GET_SERVICE_MONITOR_STATISTICS}_PENDING`:
            return {
                ...state,
                serviceMonitorStatistics: {
                    ...state.serviceMonitorStatistics,
                    isFetching: true,
                    didInvalidate: false,
                },
            };
        case `${POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD}_FULFILLED`:
            return {
                ...state,
                postNovedadesPrestadorConectividad: {
                    ...state.postNovedadesPrestadorConectividad,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD}_REJECTED`:
            return {
                ...state,
                postNovedadesPrestadorConectividad: {
                    ...state.postNovedadesPrestadorConectividad,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD}_PENDING`:
            return {
                ...state,
                postNovedadesPrestadorConectividad: {
                    ...state.postNovedadesPrestadorConectividad,
                    isFetching: true,
                    didInvalidate: false,
                },
            };
        case `${GET_NOVEDADES_PRESTADORES_CONECTIVIDAD}_FULFILLED`:
            return {
                ...state,
                novedadesPrestadorConectividad: {
                    ...state.novedadesPrestadorConectividad,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${GET_NOVEDADES_PRESTADORES_CONECTIVIDAD}_REJECTED`:
            return {
                ...state,
                novedadesPrestadorConectividad: {
                    ...state.novedadesPrestadorConectividad,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${GET_NOVEDADES_PRESTADORES_CONECTIVIDAD}_PENDING`:
            return {
                ...state,
                novedadesPrestadorConectividad: {
                    ...state.novedadesPrestadorConectividad,
                    isFetching: true,
                    didInvalidate: false,
                },
            };
        case `${GET_XML_VALIDATION}_FULFILLED`:
            return {
                ...state,
                xmlValidations: {
                    ...state.xmlValidations,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${GET_XML_VALIDATION}_REJECTED`:
            return {
                ...state,
                xmlValidations: {
                    ...state.xmlValidations,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${GET_XML_VALIDATION}_PENDING`:
            return {
                ...state,
                xmlValidations: {
                    ...state.xmlValidations,
                    isFetching: true,
                    didInvalidate: false,
                },
            };

        case `${GET_XML_NEWS}_FULFILLED`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${GET_XML_NEWS}_REJECTED`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${GET_XML_NEWS}_PENDING`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: true,
                    didInvalidate: false,
                },
            };

        case `${CLEAR_XML_NEWS}`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: false,
                    didInvalidate: false,
                    data: [],
                },
            };
        case `${RESEND_XML_NEWS}_FULFILLED`:
            return {
                ...state,
                updatedXmlNewsIds: {
                    ...state.updatedXmlNewsIds,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                }
            }
        case `${RESEND_XML_NEWS}_REJECTED`:
            return {
                ...state,
                updatedXmlNewsIds: {
                    ...state.updatedXmlNewsIds,
                    isFetching: false,
                    didInvalidate: true,
                }
            };
        case `${RESEND_XML_NEWS}_PENDING`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: true,
                    didInvalidate: false,
                },
                updatedXmlNewsIds: {
                    ...state.updatedXmlNewsIds,
                    isFetching: true,
                    didInvalidate: false,
                }
            };

        case `${UPDATE_XML_NEWS}`:
            return {
                ...state,
                xmlNews: {
                    ...state.xmlNews,
                    isFetching: false,
                    didInvalidate: false,
                    data: state.xmlNews.data.map(item => {
                        const isUpdated = action.payload.some(id => String(id) === String(item.idXmlPrestador));
                        if (isUpdated) {
                            return {
                                ...item,
                                inicioProceso: 0
                            };
                        }
                        return item;
                    })
                }
            };

        case `${GET_INDIVIDUAL_XML_NEWS}_FULFILLED`:
            return {
                ...state,
                individualXmlNews: {
                    ...state.individualXmlNews,
                    isFetching: false,
                    didInvalidate: false,
                    data: action.payload.data,
                },
            };
        case `${GET_INDIVIDUAL_XML_NEWS}_REJECTED`:
            return {
                ...state,
                individualXmlNews: {
                    ...state.individualXmlNews,
                    isFetching: false,
                    didInvalidate: true,
                },
            };
        case `${GET_INDIVIDUAL_XML_NEWS}_PENDING`:
            return {
                ...state,
                individualXmlNews: {
                    ...state.individualXmlNews,
                    isFetching: true,
                    didInvalidate: false,
                },
            };
        case `${CLEAR_INDIVIDUAL_XML_NEWS}`:
            return {
                ...state,
                individualXmlNews: {
                    ...state.individualXmlNews,
                    isFetching: false,
                    didInvalidate: false,
                    data: "",
                },
            };

        default:
            return state;
    }
};

export default connectivity;